<template>
	<el-button-group>
		<el-button
			:type="timeType === item.value ? 'primary' : ''"
			v-for="item in dateTypeDict"
			:key="item.value"
			@click="setDateType(item)"
			>{{ item.label }}
		</el-button>
	</el-button-group>
</template>

<script>
import { gaDateType } from '@/common/dictionary';
export default {
	name: 'time_range',
	props: {
		value: {
			required: true,
		},
	},
	data() {
		return {
			dateTypeDict: gaDateType,
			timeType: '',
		};
	},
	watch: {
		value: {
			handler(val) {
				this.timeType = val;
			},
			immediate: true,
		},
	},
	methods: {
		setDateType({ value }) {
			this.timeType = value;
			this.$emit('input', value);
			this.$emit('change', value);
		},
	},
};
</script>

<style scoped></style>
